import { JSX } from 'react';
import { BreakpointsProvider } from './BreakpointsContext';

export const CommonContextsProviders = (props: { children: JSX.Element }) => {
  return <BreakpointsProvider>{props.children}</BreakpointsProvider>;
};
